/* 订单录入 */
<template>
  <div id="orderInsert" class="q-pa-md">
    <PageHeader content="订单录入" />
    <el-form ref="form" :model="form" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12">
          <CustSelector ref="custSelector" />
        </el-col>
        <el-col :span="12">
          <el-form-item label="加工工厂">
            <el-select v-model="form.supplierId" placeholder="请选择类型" style="width: 100%;" clearable>
              <el-option v-for="item in supplierList" :key="item.id" :label="item.supplierName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="订单编号">
            <el-input v-model="form.orderNo">
              <el-button slot="append" icon="el-icon-edit" @click="getOrderNo">生成订单编号</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户订单号">
            <el-input v-model="form.customerOrderNo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <YarnSelector ref="yarnSelector" />
        </el-col>
        <el-col :span="12">
          <el-form-item label="类型">
            <el-select v-model="form.roundType" placeholder="请选择类型" style="width: 100%;" clearable>
              <el-option label="筒纱" value="筒纱"></el-option>
              <el-option label="绞纱" value="绞纱"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="是否购销">
            <el-select v-model="form.delivery" placeholder="请选择是否购销" style="width: 100%;">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否并线">
            <el-select v-model="form.combine" placeholder="请选择是否并线" style="width: 100%;">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="订单日期">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.orderDate" value-format="yyyy-MM-dd"
              style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="期望交期">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.deliveryDate" value-format="yyyy-MM-dd"
              style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="订单价格">
            <el-input v-model="form.orderPrice"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="照片附件">
            <Upload ref="upload" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="订单明细">
        <OrderItemTable ref="orderItemTable" />
      </el-form-item>

      <el-form-item label="客户备注">
        <el-input type="textarea" v-model="form.customerRemark" :autosize="{ minRows: 4, maxRows: 10 }"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="createOrder">立即创建</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>


<script>
import PageHeader from "../components/PageHeader.vue";
import OrderItemTable from "../components/OrderItemTable.vue";
import CustSelector from "../components/CustSelector.vue";
import Upload from "../components/Upload.vue";
import YarnSelector from "@/components/YarnSelector.vue";
import { list } from "@/api/erp/supplier"
export default {
  components: {
    PageHeader,
    OrderItemTable,
    CustSelector,
    Upload,
    YarnSelector,
  },
  data() {
    return {
      form: { orderNo: "" },
      supplierList: []
    };
  },
  methods: {
    createOrder() {
      this.form.orderItems = this.$refs.orderItemTable.tableData;
      this.form.customerNo = this.$refs.custSelector.customerNo;
      this.form.yarnType = this.$refs.yarnSelector.selectYarnId;
      this.form.pictures = JSON.stringify(this.$refs.upload.fileList);
      console.log(JSON.stringify(this.form));
      var self = this;
      this.$axios.post("/order/create", self.form).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.$message({
            message: "保存成功",
            type: "success",
          });
          self.$router.push("/order");
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    getOrderNo() {
      var self = this;
      this.$axios.get("/order/getOrderNo").then(function (response) {
        if (response.data.errorCode == "00000") {
          self.form.orderNo = response.data.data;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    cancel() {
      this.$router.push("/order");
    },
  },
  created: function () {
    console.log("OrderInsert created");
    this.getOrderNo();
    var self = this;
    list().then((response) => {
      self.supplierList = response.data.data.list;
    });
  },
};
</script>

<style scoped>
.el-form {
  --width: 600px;
  margin-top: 50px;
}
</style>